import {
  HMSPeer,
  selectPeerAudioByID,
  useHMSStore,
} from "@100mslive/react-sdk";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { Child } from "../../api/child";
import { globalStores } from "../../api/globalStores";
import Avatar from "../../Common/Avatars/Avatar";
import IconMic from "../../Common/Icons/IconMic";

interface IAvatarGridItem {
  participant: HMSPeer | undefined;
}

export default observer(AvatarGridItem);

function AvatarGridItem(props: IAvatarGridItem) {
  const [child, setChild] = useState<Child | undefined>(undefined);
  const [icon, setIcon] = useState<"bear" | "biker" | "boy" | "dino">("bear");

  const audioLevel = useHMSStore(selectPeerAudioByID(props.participant?.id));
  const isAudioDegraded = globalStores.curTalkingParty.isTrackDegraded(
    props.participant?.audioTrack
  );

  useEffect(() => {
    (async () => {
      if (!props.participant?.customerUserId) return;
      const parsedId = JSON.parse(props.participant.customerUserId);
      const studentId = parsedId.studentId;
      if (!studentId) return;
      const newChild = new Child();
      await newChild.init(studentId);
      setChild(newChild);
      const newIcon = Child.getIcon(newChild);
      setIcon(newIcon);
    })();
  }, [props.participant?.customerUserId]);

  const name = child
    ? child.userDetail.firstName +
      " " +
      child.userDetail.lastName?.charAt(0) +
      "."
    : "";

  return (
    <div className="inline-flex flex-col gap-1 items-center justify-center z-30 relative">
      <div className="h-16 w-16 relative">
        {isAudioDegraded && (
          <div className="absolute -top-1 -right-1 z-40 bg-brij-Orange text-white rounded-full p-1 animate-pulse border-2 border-white">
            <div className="w-3 h-3 flex items-center justify-center">
              <IconMic />
            </div>
          </div>
        )}
        {/* <div className="w-full h-full rounded-full animate-pulse bg-red-400" /> */}
        <Avatar
          icon={icon}
          active={true}
          large
          //TODO: Pulsation based on volume
          pulsate={audioLevel > 0}
        />
      </div>
      <div className="text-small">{name}</div>
      {/* <AudioTrack track={props.participant ? audioTrack : undefined} /> */}
    </div>
  );
}
